import "core-js/modules/es.array.push.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-3a2a8f0c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "index blueBgc"
};
const _hoisted_2 = {
  class: "bannerInner"
};
const _hoisted_3 = {
  class: "bannerTitle1"
};
const _hoisted_4 = {
  class: "bannerTitle2"
};
const _hoisted_5 = {
  class: "section-IntroductionBox"
};
const _hoisted_6 = {
  class: "IntroInner wrapper"
};
const _hoisted_7 = {
  class: "aboutImg container-about"
};
const _hoisted_8 = ["src"];
const _hoisted_9 = {
  class: "container-about"
};
const _hoisted_10 = {
  class: "divTitle"
};
const _hoisted_11 = {
  class: "divTxt whiteFont"
};
const _hoisted_12 = {
  class: "section-Advantages section-service"
};
const _hoisted_13 = {
  class: "wrapper"
};
const _hoisted_14 = {
  class: "container-advantages"
};
const _hoisted_15 = {
  class: "divTitle"
};
const _hoisted_16 = {
  class: "divTxt"
};
const _hoisted_17 = {
  class: "advantages-guild"
};
const _hoisted_18 = {
  class: "advantItem container-advant"
};
const _hoisted_19 = {
  class: "advantImg"
};
const _hoisted_20 = ["src"];
const _hoisted_21 = {
  class: "advantIco"
};
const _hoisted_22 = ["src"];
const _hoisted_23 = {
  class: "advantCont"
};
const _hoisted_24 = {
  class: "advantItem container-advant"
};
const _hoisted_25 = {
  class: "advantImg"
};
const _hoisted_26 = ["src"];
const _hoisted_27 = {
  class: "advantIco"
};
const _hoisted_28 = ["src"];
const _hoisted_29 = {
  class: "advantCont"
};
const _hoisted_30 = {
  class: "advantItem container-advant"
};
const _hoisted_31 = {
  class: "advantImg"
};
const _hoisted_32 = ["src"];
const _hoisted_33 = {
  class: "advantIco"
};
const _hoisted_34 = ["src"];
const _hoisted_35 = {
  class: "advantCont"
};
const _hoisted_36 = {
  class: "advantItem container-advant"
};
const _hoisted_37 = {
  class: "advantImg"
};
const _hoisted_38 = ["src"];
const _hoisted_39 = {
  class: "advantIco"
};
const _hoisted_40 = ["src"];
const _hoisted_41 = {
  class: "advantCont"
};
const _hoisted_42 = {
  class: "section-Leading section-service"
};
const _hoisted_43 = {
  class: "leadingInner wrapper"
};
const _hoisted_44 = {
  class: "container-leading"
};
const _hoisted_45 = {
  class: "divTitle"
};
const _hoisted_46 = {
  class: "divTxt"
};
const _hoisted_47 = {
  class: "leading-guild"
};
const _hoisted_48 = {
  class: "leadingItem"
};
const _hoisted_49 = {
  class: "leadingImg"
};
const _hoisted_50 = ["src"];
const _hoisted_51 = {
  class: "leadingCont"
};
const _hoisted_52 = {
  class: "leadingItem"
};
const _hoisted_53 = {
  class: "leadingImg"
};
const _hoisted_54 = ["src"];
const _hoisted_55 = {
  class: "leadingCont"
};
const _hoisted_56 = {
  class: "leadingItem"
};
const _hoisted_57 = {
  class: "leadingImg"
};
const _hoisted_58 = ["src"];
const _hoisted_59 = {
  class: "leadingCont"
};
const _hoisted_60 = {
  class: "leadingItem"
};
const _hoisted_61 = {
  class: "leadingImg"
};
const _hoisted_62 = ["src"];
const _hoisted_63 = {
  class: "leadingCont"
};
const _hoisted_64 = {
  class: "leadingItem"
};
const _hoisted_65 = {
  class: "leadingImg"
};
const _hoisted_66 = ["src"];
const _hoisted_67 = {
  class: "leadingCont"
};
const _hoisted_68 = {
  class: "leadingItem"
};
const _hoisted_69 = {
  class: "leadingImg"
};
const _hoisted_70 = ["src"];
const _hoisted_71 = {
  class: "leadingCont"
};
const _hoisted_72 = {
  class: "leadingItem"
};
const _hoisted_73 = {
  class: "leadingImg"
};
const _hoisted_74 = ["src"];
const _hoisted_75 = {
  class: "leadingCont"
};
const _hoisted_76 = {
  class: "leadingItem"
};
const _hoisted_77 = {
  class: "leadingImg"
};
const _hoisted_78 = ["src"];
const _hoisted_79 = {
  class: "leadingCont"
};
const _hoisted_80 = {
  class: "section-join"
};
const _hoisted_81 = {
  class: "join-txt"
};
const _hoisted_82 = {
  class: "whiteFont"
};
const _hoisted_83 = {
  class: "section-agency"
};
const _hoisted_84 = {
  class: "agencyInner wrapper"
};
const _hoisted_85 = {
  class: "container-leading"
};
const _hoisted_86 = {
  class: "divTitle"
};
const _hoisted_87 = {
  class: "divTxt whiteFont"
};
const _hoisted_88 = {
  class: "agency-swipe"
};
const _hoisted_89 = {
  class: "agencyItem"
};
const _hoisted_90 = {
  class: "agencyImg"
};
const _hoisted_91 = ["src"];
const _hoisted_92 = {
  class: "agencyCont"
};
const _hoisted_93 = {
  class: "whiteFont"
};
const _hoisted_94 = {
  class: "agencyItem"
};
const _hoisted_95 = {
  class: "agencyImg"
};
const _hoisted_96 = ["src"];
const _hoisted_97 = {
  class: "agencyCont"
};
const _hoisted_98 = {
  class: "whiteFont"
};
const _hoisted_99 = {
  class: "agencyItem"
};
const _hoisted_100 = {
  class: "agencyImg"
};
const _hoisted_101 = ["src"];
const _hoisted_102 = {
  class: "agencyCont"
};
const _hoisted_103 = {
  class: "whiteFont"
};
const _hoisted_104 = {
  class: "lowest"
};
const _hoisted_105 = {
  class: "container"
};
const _hoisted_106 = {
  class: "block"
};
const _hoisted_107 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_image = _resolveComponent("van-image");
  const _component_van_button = _resolveComponent("van-button");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_image, {
    class: "bannerBgi",
    fit: "cover",
    position: "bottom",
    width: "100%",
    src: require('@/assets/img/bannerImg.jpg')
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.$t('index.bannerTip')), 1), _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.$t('index.bannerTitle')), 1), !_ctx.userToken ? (_openBlock(), _createElementBlock("a", {
      key: 0,
      onClick: _cache[0] || (_cache[0] = $event => _ctx.$router.push('/login'))
    }, _toDisplayString(_ctx.$t('navtab.login')), 1)) : (_openBlock(), _createElementBlock("a", {
      key: 1,
      onClick: _cache[1] || (_cache[1] = $event => _ctx.$router.push('/memberCenter'))
    }, _toDisplayString(_ctx.$t('btn.start')), 1))]), _createVNode(_component_van_image, {
      width: "400px",
      class: "innerImg",
      src: require('@/assets/img/mobile.png')
    }, null, 8, ["src"])]),
    _: 1
  }, 8, ["src"]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("img", {
    width: "100%",
    src: require('@/assets/img/aboutImg.jpg'),
    alt: ""
  }, null, 8, _hoisted_8)]), _createElementVNode("div", _hoisted_9, [_createElementVNode("h2", _hoisted_10, _toDisplayString(_ctx.$t('index.block2Title')), 1), _createElementVNode("div", _hoisted_11, [_createElementVNode("p", null, _toDisplayString(_ctx.$t('index.block2Tip1')), 1), _createElementVNode("p", null, _toDisplayString(_ctx.$t('index.block2Tip2')), 1), !_ctx.userToken ? (_openBlock(), _createElementBlock("a", {
    key: 0,
    class: "btn btn-primary py-3 px-4",
    onClick: _cache[2] || (_cache[2] = $event => _ctx.$router.push('/login'))
  }, _toDisplayString(_ctx.$t('btn.OverviewMore')), 1)) : (_openBlock(), _createElementBlock("a", {
    key: 1,
    class: "btn btn-primary py-3 px-4",
    onClick: _cache[3] || (_cache[3] = $event => _ctx.$router.push('/memberCenter'))
  }, _toDisplayString(_ctx.$t('btn.start')), 1))])])])]), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createElementVNode("h2", _hoisted_15, _toDisplayString(_ctx.$t('index.block3Title')), 1), _createElementVNode("div", _hoisted_16, [_createElementVNode("p", null, _toDisplayString(_ctx.$t('index.block3Tip')), 1)])]), _createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, [_createElementVNode("img", {
    width: "100%",
    src: require('@/assets/img/palace-1.png'),
    alt: ""
  }, null, 8, _hoisted_20), _createElementVNode("div", _hoisted_21, [_createElementVNode("img", {
    width: "100%",
    src: require('@/assets/img/icon-s01.png'),
    alt: ""
  }, null, 8, _hoisted_22)])]), _createElementVNode("div", _hoisted_23, [_createElementVNode("h3", null, _toDisplayString(_ctx.$t('index.block3ItemTitle1')), 1), _createElementVNode("p", null, _toDisplayString(_ctx.$t('index.block3ItemTip1')), 1)])]), _createElementVNode("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, [_createElementVNode("img", {
    width: "100%",
    src: require('@/assets/img/palace-2.png'),
    alt: ""
  }, null, 8, _hoisted_26), _createElementVNode("div", _hoisted_27, [_createElementVNode("img", {
    width: "100%",
    src: require('@/assets/img/icon-s02.png'),
    alt: ""
  }, null, 8, _hoisted_28)])]), _createElementVNode("div", _hoisted_29, [_createElementVNode("h3", null, _toDisplayString(_ctx.$t('index.block3ItemTitle2')), 1), _createElementVNode("p", null, _toDisplayString(_ctx.$t('index.block3ItemTip2')), 1)])]), _createElementVNode("div", _hoisted_30, [_createElementVNode("div", _hoisted_31, [_createElementVNode("img", {
    width: "100%",
    src: require('@/assets/img/palace-3.png'),
    alt: ""
  }, null, 8, _hoisted_32), _createElementVNode("div", _hoisted_33, [_createElementVNode("img", {
    width: "100%",
    src: require('@/assets/img/icon-s03.png'),
    alt: ""
  }, null, 8, _hoisted_34)])]), _createElementVNode("div", _hoisted_35, [_createElementVNode("h3", null, _toDisplayString(_ctx.$t('index.block3ItemTitle3')), 1), _createElementVNode("p", null, _toDisplayString(_ctx.$t('index.block3ItemTip3')), 1)])]), _createElementVNode("div", _hoisted_36, [_createElementVNode("div", _hoisted_37, [_createElementVNode("img", {
    width: "100%",
    src: require('@/assets/img/palace-4.png'),
    alt: ""
  }, null, 8, _hoisted_38), _createElementVNode("div", _hoisted_39, [_createElementVNode("img", {
    width: "100%",
    src: require('@/assets/img/icon-s04.png'),
    alt: ""
  }, null, 8, _hoisted_40)])]), _createElementVNode("div", _hoisted_41, [_createElementVNode("h3", null, _toDisplayString(_ctx.$t('index.block3ItemTitle4')), 1), _createElementVNode("p", null, _toDisplayString(_ctx.$t('index.block3ItemTip4')), 1)])])])])]), _createElementVNode("div", _hoisted_42, [_createElementVNode("div", _hoisted_43, [_createElementVNode("div", _hoisted_44, [_createElementVNode("h2", _hoisted_45, _toDisplayString(_ctx.$t('index.block4Title')), 1), _createElementVNode("div", _hoisted_46, [_createElementVNode("p", null, _toDisplayString(_ctx.$t('index.block4Tip')), 1)])]), _createElementVNode("div", _hoisted_47, [_createElementVNode("div", _hoisted_48, [_createElementVNode("div", _hoisted_49, [_createElementVNode("img", {
    width: "100%",
    src: require('@/assets/img/c-1.png'),
    alt: ""
  }, null, 8, _hoisted_50)]), _createElementVNode("div", _hoisted_51, [_createElementVNode("h3", null, _toDisplayString(_ctx.$t('goodsCat.beauty')), 1), !_ctx.userToken ? (_openBlock(), _createBlock(_component_van_button, {
    key: 0,
    onClick: _cache[4] || (_cache[4] = $event => _ctx.$router.push('/login')),
    block: "",
    type: "primary"
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('btn.startNow')), 1)]),
    _: 1
  })) : (_openBlock(), _createBlock(_component_van_button, {
    key: 1,
    onClick: _cache[5] || (_cache[5] = $event => _ctx.$router.push('/memberCenter')),
    block: "",
    type: "primary"
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('btn.startNow')), 1)]),
    _: 1
  }))])]), _createElementVNode("div", _hoisted_52, [_createElementVNode("div", _hoisted_53, [_createElementVNode("img", {
    width: "100%",
    src: require('@/assets/img/c-2.png'),
    alt: ""
  }, null, 8, _hoisted_54)]), _createElementVNode("div", _hoisted_55, [_createElementVNode("h3", null, _toDisplayString(_ctx.$t('goodsCat.food')), 1), !_ctx.userToken ? (_openBlock(), _createBlock(_component_van_button, {
    key: 0,
    onClick: _cache[6] || (_cache[6] = $event => _ctx.$router.push('/login')),
    block: "",
    type: "primary"
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('btn.startNow')), 1)]),
    _: 1
  })) : (_openBlock(), _createBlock(_component_van_button, {
    key: 1,
    onClick: _cache[7] || (_cache[7] = $event => _ctx.$router.push('/memberCenter')),
    block: "",
    type: "primary"
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('btn.startNow')), 1)]),
    _: 1
  }))])]), _createElementVNode("div", _hoisted_56, [_createElementVNode("div", _hoisted_57, [_createElementVNode("img", {
    width: "100%",
    src: require('@/assets/img/c-3.png'),
    alt: ""
  }, null, 8, _hoisted_58)]), _createElementVNode("div", _hoisted_59, [_createElementVNode("h3", null, _toDisplayString(_ctx.$t('goodsCat.necessary')), 1), !_ctx.userToken ? (_openBlock(), _createBlock(_component_van_button, {
    key: 0,
    onClick: _cache[8] || (_cache[8] = $event => _ctx.$router.push('/login')),
    block: "",
    type: "primary"
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('btn.startNow')), 1)]),
    _: 1
  })) : (_openBlock(), _createBlock(_component_van_button, {
    key: 1,
    onClick: _cache[9] || (_cache[9] = $event => _ctx.$router.push('/memberCenter')),
    block: "",
    type: "primary"
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('btn.startNow')), 1)]),
    _: 1
  }))])]), _createElementVNode("div", _hoisted_60, [_createElementVNode("div", _hoisted_61, [_createElementVNode("img", {
    width: "100%",
    src: require('@/assets/img/c-4.png'),
    alt: ""
  }, null, 8, _hoisted_62)]), _createElementVNode("div", _hoisted_63, [_createElementVNode("h3", null, _toDisplayString(_ctx.$t('goodsCat.ClothesShoes')), 1), !_ctx.userToken ? (_openBlock(), _createBlock(_component_van_button, {
    key: 0,
    onClick: _cache[10] || (_cache[10] = $event => _ctx.$router.push('/login')),
    block: "",
    type: "primary"
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('btn.startNow')), 1)]),
    _: 1
  })) : (_openBlock(), _createBlock(_component_van_button, {
    key: 1,
    onClick: _cache[11] || (_cache[11] = $event => _ctx.$router.push('/memberCenter')),
    block: "",
    type: "primary"
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('btn.startNow')), 1)]),
    _: 1
  }))])]), _createElementVNode("div", _hoisted_64, [_createElementVNode("div", _hoisted_65, [_createElementVNode("img", {
    width: "100%",
    src: require('@/assets/img/c-5.png'),
    alt: ""
  }, null, 8, _hoisted_66)]), _createElementVNode("div", _hoisted_67, [_createElementVNode("h3", null, _toDisplayString(_ctx.$t('goodsCat.Infants')), 1), !_ctx.userToken ? (_openBlock(), _createBlock(_component_van_button, {
    key: 0,
    onClick: _cache[12] || (_cache[12] = $event => _ctx.$router.push('/login')),
    block: "",
    type: "primary"
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('btn.startNow')), 1)]),
    _: 1
  })) : (_openBlock(), _createBlock(_component_van_button, {
    key: 1,
    onClick: _cache[13] || (_cache[13] = $event => _ctx.$router.push('/memberCenter')),
    block: "",
    type: "primary"
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('btn.startNow')), 1)]),
    _: 1
  }))])]), _createElementVNode("div", _hoisted_68, [_createElementVNode("div", _hoisted_69, [_createElementVNode("img", {
    width: "100%",
    src: require('@/assets/img/c-6.png'),
    alt: ""
  }, null, 8, _hoisted_70)]), _createElementVNode("div", _hoisted_71, [_createElementVNode("h3", null, _toDisplayString(_ctx.$t('goodsCat.Electrical')), 1), !_ctx.userToken ? (_openBlock(), _createBlock(_component_van_button, {
    key: 0,
    onClick: _cache[14] || (_cache[14] = $event => _ctx.$router.push('/login')),
    block: "",
    type: "primary"
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('btn.startNow')), 1)]),
    _: 1
  })) : (_openBlock(), _createBlock(_component_van_button, {
    key: 1,
    onClick: _cache[15] || (_cache[15] = $event => _ctx.$router.push('/memberCenter')),
    block: "",
    type: "primary"
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('btn.startNow')), 1)]),
    _: 1
  }))])]), _createElementVNode("div", _hoisted_72, [_createElementVNode("div", _hoisted_73, [_createElementVNode("img", {
    width: "100%",
    src: require('@/assets/img/c-7.png'),
    alt: ""
  }, null, 8, _hoisted_74)]), _createElementVNode("div", _hoisted_75, [_createElementVNode("h3", null, _toDisplayString(_ctx.$t('goodsCat.SkinCare')), 1), !_ctx.userToken ? (_openBlock(), _createBlock(_component_van_button, {
    key: 0,
    onClick: _cache[16] || (_cache[16] = $event => _ctx.$router.push('/login')),
    block: "",
    type: "primary"
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('btn.startNow')), 1)]),
    _: 1
  })) : (_openBlock(), _createBlock(_component_van_button, {
    key: 1,
    onClick: _cache[17] || (_cache[17] = $event => _ctx.$router.push('/memberCenter')),
    block: "",
    type: "primary"
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('btn.startNow')), 1)]),
    _: 1
  }))])]), _createElementVNode("div", _hoisted_76, [_createElementVNode("div", _hoisted_77, [_createElementVNode("img", {
    width: "100%",
    src: require('@/assets/img/c-8.png'),
    alt: ""
  }, null, 8, _hoisted_78)]), _createElementVNode("div", _hoisted_79, [_createElementVNode("h3", null, _toDisplayString(_ctx.$t('goodsCat.SmallThings')), 1), !_ctx.userToken ? (_openBlock(), _createBlock(_component_van_button, {
    key: 0,
    onClick: _cache[18] || (_cache[18] = $event => _ctx.$router.push('/login')),
    block: "",
    type: "primary"
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('btn.startNow')), 1)]),
    _: 1
  })) : (_openBlock(), _createBlock(_component_van_button, {
    key: 1,
    onClick: _cache[19] || (_cache[19] = $event => _ctx.$router.push('/memberCenter')),
    block: "",
    type: "primary"
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('btn.startNow')), 1)]),
    _: 1
  }))])])])])]), _createElementVNode("div", _hoisted_80, [_createVNode(_component_van_image, {
    class: "join-img whiteBgc",
    height: "30",
    src: require('@/assets/img/logo.png')
  }, null, 8, ["src"]), _createElementVNode("div", _hoisted_81, [_createElementVNode("p", _hoisted_82, _toDisplayString(_ctx.$t('index.block5Tip')), 1), !_ctx.userToken ? (_openBlock(), _createBlock(_component_van_button, {
    key: 0,
    onClick: _cache[20] || (_cache[20] = $event => _ctx.$router.push('/login')),
    type: "primary"
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('btn.QuickOverview')), 1)]),
    _: 1
  })) : (_openBlock(), _createBlock(_component_van_button, {
    key: 1,
    onClick: _cache[21] || (_cache[21] = $event => _ctx.$router.push('/memberCenter')),
    type: "primary"
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('btn.QuickOverview')), 1)]),
    _: 1
  }))])]), _createElementVNode("div", _hoisted_83, [_createElementVNode("div", _hoisted_84, [_createElementVNode("div", _hoisted_85, [_createElementVNode("h2", _hoisted_86, _toDisplayString(_ctx.$t('index.block5Title')), 1), _createElementVNode("div", _hoisted_87, [_createElementVNode("p", null, _toDisplayString(_ctx.$t('index.block5Tip')), 1)])]), _createElementVNode("div", _hoisted_88, [_createElementVNode("div", _hoisted_89, [_createElementVNode("div", _hoisted_90, [_createElementVNode("img", {
    width: "100%",
    src: require('@/assets/img/agency-2.jpg'),
    alt: ""
  }, null, 8, _hoisted_91)]), _createElementVNode("div", _hoisted_92, [_createElementVNode("h4", _hoisted_93, _toDisplayString(_ctx.$t('index.block5Item1')), 1)])]), _createElementVNode("div", _hoisted_94, [_createElementVNode("div", _hoisted_95, [_createElementVNode("img", {
    width: "100%",
    src: require('@/assets/img/agency-3.png'),
    alt: ""
  }, null, 8, _hoisted_96)]), _createElementVNode("div", _hoisted_97, [_createElementVNode("h4", _hoisted_98, _toDisplayString(_ctx.$t('index.block5Item2')), 1)])]), _createElementVNode("div", _hoisted_99, [_createElementVNode("div", _hoisted_100, [_createElementVNode("img", {
    width: "100%",
    src: require('@/assets/img/agency-4.jpg'),
    alt: ""
  }, null, 8, _hoisted_101)]), _createElementVNode("div", _hoisted_102, [_createElementVNode("h4", _hoisted_103, _toDisplayString(_ctx.$t('index.block5Item3')), 1)])])])])]), _createElementVNode("div", _hoisted_104, [_createElementVNode("div", _hoisted_105, [_createElementVNode("div", _hoisted_106, [_createElementVNode("img", {
    src: require('@/assets/img/logo.png'),
    alt: "",
    class: "logo"
  }, null, 8, _hoisted_107), _createElementVNode("p", null, _toDisplayString(_ctx.$t('index.companyInfo')), 1)])])])]);
}